import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import useScrollOnMount from "src/hooks/App/useScrollOnMount";
import PagesHistory from "../shared/minicomponents/pagehistory/PagesHistory";
import s from "./Cart.module.scss";
import CartButtons from "./cartbuttons/CartButtons";
import AddCoupon from "./cartinfo/AddCoupon";
import CartInfoMenu from "./cartinfo/CartInfoMenu";
import CartProducts from "./cartproduct/CartProducts";

const Cart = () => {
  const { t } = useTranslation();

  useScrollOnMount(200);

  return (
    <>
      <Helmet>
        <title>Cart</title>
        <meta
          name="description"
          content="Review and manage your selected items in the Exclusive cart. Add products, apply coupons, and proceed to checkout for a seamless shopping experience."
        />
      </Helmet>

      <div className="container">
        <main className={s.cartPage}>
          <PagesHistory history={["/", t("history.cart")]} />

          <div className={s.pageComponents} id="cart-page">
            <CartProducts />
            <CartButtons />

            <div className={s.wrapper}>
              <AddCoupon />
              <CartInfoMenu />
            </div>
          </div>
        </main>
      </div>
    </>
  );
};
export default Cart;
